/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Equivalence_BoeingInputs */

const en_us2_equivalence_boeing = /** @type {(inputs: Equivalence_BoeingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`the weight of a Boeing 737`);
	return /** @type {LocalizedString} */ (`the weight of ${i?.amount} Boeing 737s`)
	
};

const pt_br2_equivalence_boeing = /** @type {(inputs: Equivalence_BoeingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um Boeing 737`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} Boeings 737`)
	
};

const es_419_equivalence_boeing = /** @type {(inputs: Equivalence_BoeingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`el peso de un Boeing 737`);
	return /** @type {LocalizedString} */ (`el peso de ${i?.amount} Boeing 737`)
	
};

const pt_pt2_equivalence_boeing = /** @type {(inputs: Equivalence_BoeingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um Boeing 737`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} Boeings 737`)
	
};

const fr_fr2_equivalence_boeing = /** @type {(inputs: Equivalence_BoeingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`le poids d'un Boeing 737`);
	return /** @type {LocalizedString} */ (`le poids de ${i?.amount} Boeing 737`)
	
};

const de_de2_equivalence_boeing = /** @type {(inputs: Equivalence_BoeingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`das Gewicht einer Boeing 737`);
	return /** @type {LocalizedString} */ (`das Gewicht von ${i?.amount} Boeing 737`)
	
};

const it_it2_equivalence_boeing = /** @type {(inputs: Equivalence_BoeingInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`il peso di un Boeing 737`);
	return /** @type {LocalizedString} */ (`il peso di ${i?.amount} Boeing 737`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "the weight of a Boeing 737" |
* | * | "the weight of {amount} Boeing 737s" |
*
* @param {Equivalence_BoeingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_boeing = /** @type {((inputs: Equivalence_BoeingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_BoeingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_boeing(inputs)
	if (locale === "es-419") return es_419_equivalence_boeing(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_boeing(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_boeing(inputs)
	if (locale === "de-DE") return de_de2_equivalence_boeing(inputs)
	if (locale === "it-IT") return it_it2_equivalence_boeing(inputs)
	return en_us2_equivalence_boeing(inputs)
});
export { equivalence_boeing as "equivalence.boeing" }